import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { TwoFactorLoginStep } from './TwoFactorLoginStep'

export type SwitchTwoFactorPhase =
  | { kind: 'challenge'; challengeToken: string }
  | { kind: 'enroll'; setupToken: string; orgName?: string }

/**
 * Modal that completes a tenant switch which the backend gated behind 2FA
 * (step-up challenge or forced enrollment). Reuses the same TwoFactorLoginStep as
 * the login screen; on success the session is already applied by the step and the
 * caller is notified via onAuthenticated.
 */
export function TenantSwitch2FADialog({
  phase,
  onAuthenticated,
  onCancel,
}: {
  phase: SwitchTwoFactorPhase | null
  onAuthenticated: () => void
  onCancel: () => void
}) {
  const { t } = useTranslation('auth')

  return (
    <Dialog open={phase !== null} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('twoFactor.challenge.title')}</DialogTitle>
        </DialogHeader>
        {phase && (
          <TwoFactorLoginStep phase={phase} onAuthenticated={onAuthenticated} onBack={onCancel} />
        )}
      </DialogContent>
    </Dialog>
  )
}
